import React, { useEffect, useMemo, useState } from "react";
import { Dimensions, Platform, ScrollView, StyleSheet, View } from "react-native";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TextAlignTokens } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import Accordion from "../component/accordian/accordian";
import AccordionItem from "../component/accordian/accordianItem";
import { Row, Table } from "react-native-table-component";
import { getAutoDebitDate, getLenderIcon, isFromTDLPlatform, returnDateInString } from "../utils";
import { hasOnlyDescriptionAndValue, hasPropertySubText } from "./utils";
import ThemeProvider from "@voltmoney/theme";
const KFSPage = ({ height, goBack, getEmailStatementAction, triggerAction, emailStatementButtonLoading = false, kfs_data, lenderData, isDarkMode }) => {
    const [_lenderData, setLenderData] = useState(lenderData);
    const [_loading, setLoading] = useState(false);
    const [kfsData, setKfsData] = useState(kfs_data);
    const interestDuePerMonth = (_lenderData.lenderBusinessDetails.annualizedInterestRate / 100) * 10000;
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    useEffect(() => {
        setLoading(emailStatementButtonLoading);
    }, [emailStatementButtonLoading]);
    const handleGoBack = () => {
        goBack &&
            triggerAction(goBack);
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(View, { style: {
                        width: 8
                    } }),
                React.createElement(Typography, { label: 'Key fact statement', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24 }))));
    }, []);
    const overViewDetailCard = (React.createElement(View, { style: {
            width: '100%',
            backgroundColor: isDarkMode ? '#1C1E24' : '#FFF',
            paddingTop: 14,
            paddingBottom: 12,
            paddingHorizontal: 16
        } },
        React.createElement(Typography, { label: 'Overview', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500 }),
        React.createElement(View, { style: { height: 12 } }),
        React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
            } },
            React.createElement(Typography, { label: 'Date', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500 }),
            React.createElement(Typography, { label: `${returnDateInString(Date.now())}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500, lineHeight: 20 })),
        React.createElement(View, { style: { height: 12 } }),
        React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
            } },
            React.createElement(View, { style: {
                    flex: 1
                } },
                React.createElement(Typography, { label: 'Entity name', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, numberOfLines: 2, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500 })),
            React.createElement(View, { style: {
                    flex: 1
                } },
                React.createElement(Typography, { label: `${_lenderData?.lenderName}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, numberOfLines: 2, textAlign: TextAlignTokens.right, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500 })))));
    const renderInterestRepaymentTable = () => {
        const tableHead = ["Withdrawal amount", "Monthly interest", "Due on"];
        const flexArr = [1, 1, 2];
        const dataRow = [
            '₹10,000',
            `${_lenderData.lenderBusinessDetails.annualizedInterestRate}%`,
            `${getAutoDebitDate(_lenderData.lenderBusinessDetails.autopayDate)}`
        ];
        return (React.createElement(View, null,
            React.createElement(Table, { borderStyle: {
                    borderColor: "#E4E7EC",
                    borderWidth: 1,
                } },
                React.createElement(Row, { data: tableHead, flexArr: flexArr, style: styles.tableHead, textStyle: styles.tableHeadText })),
            React.createElement(ScrollView, { style: styles.tableDataWrapper },
                React.createElement(Table, { borderStyle: {
                        borderColor: "#E4E7EC",
                        borderWidth: 1,
                    } },
                    React.createElement(Row
                    // key={index}
                    , { 
                        // key={index}
                        data: dataRow, flexArr: flexArr, style: [styles.tableRow,
                            { backgroundColor: "#ffffff" },
                        ], textStyle: styles.tableText, fontFamily: isFromTDLPlatform() ? "InterSimonson" : "" })))));
    };
    const renderPrincipalRepaymentTable = () => {
        const tableHead = ["Withdrawal amount", "Due on"];
        const flexArr = [1, 2];
        const dataRow = [
            '₹10,000',
            'Repay anytime'
        ];
        return (React.createElement(View, null,
            React.createElement(Table, { borderStyle: {
                    borderColor: "#E4E7EC",
                    borderWidth: 1,
                } },
                React.createElement(Row, { data: tableHead, flexArr: flexArr, style: styles.tableHead, textStyle: styles.tableHeadText, fontFamily: isFromTDLPlatform() ? "InterSimonson" : "" })),
            React.createElement(ScrollView, { style: styles.tableDataWrapper },
                React.createElement(Table, { borderStyle: {
                        borderColor: "#E4E7EC",
                        borderWidth: 1,
                    } },
                    React.createElement(Row
                    // key={index}
                    , { 
                        // key={index}
                        data: dataRow, flexArr: flexArr, style: [styles.tableRow,
                            { backgroundColor: "#ffffff" },
                        ], textStyle: styles.tableText, fontFamily: isFromTDLPlatform() ? "InterSimonson" : "" })))));
    };
    const renderRepaymentCalculationCard = () => {
        const repaymentCardItems = [
            {
                title: 'Withdrawal Amount:',
                value: '₹10,000'
            },
            {
                title: 'Interest Rate',
                value: `${(_lenderData.lenderBusinessDetails.annualizedInterestRate / 12).toFixed(2)}% per month ( @${lenderData.lenderBusinessDetails.annualizedInterestRate}% per year)`
            },
            {
                title: 'Interest due (based on withdrawal amount)',
                value: `₹${((interestDuePerMonth) / 12).toFixed(2)} per month`
            },
            {
                title: 'Principal repayment',
                value: 'Repay principal amount anytime'
            },
        ];
        return (React.createElement(View, { style: {
                padding: 12,
                backgroundColor: '#F9FAFB',
            } },
            React.createElement(Typography, { label: `Repayment calculation (illustrative)`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, numberOfLines: 2 }),
            repaymentCardItems.map((item) => (React.createElement(View, { style: {
                    paddingTop: 16
                } },
                React.createElement(Typography, { label: `${item.title}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20 }),
                React.createElement(Typography, { label: `${item.value}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20 }))))));
    };
    const detailRepaymentScheduleCard = (React.createElement(View, { style: {
            paddingTop: 16,
        } },
        React.createElement(View, null,
            React.createElement(Typography, { label: ` Interest repayment`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500 }),
            React.createElement(View, { style: { height: 8 } }),
            renderInterestRepaymentTable(),
            React.createElement(View, { style: { height: 16 } }),
            React.createElement(Typography, { label: `Principal repayment`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500, lineHeight: 20 }),
            React.createElement(View, { style: { height: 8 } }),
            renderPrincipalRepaymentTable(),
            React.createElement(View, { style: { height: 24 } }),
            renderRepaymentCalculationCard())));
    const renderFactItem = (_renderItem) => {
        const renderItems = [];
        const generateFactItem = (item) => {
            if (typeof item !== "object") {
                return null;
            }
            if (typeof item === "object" && !hasOnlyDescriptionAndValue(item)) {
                renderItems.push({
                    ...item,
                    isSubtitle: true
                });
                Object.keys(item).map((key, index) => {
                    return (React.createElement(React.Fragment, null, generateFactItem(item[key])));
                });
            }
            if (typeof item === "object" &&
                hasPropertySubText(item)) {
                renderItems.push({
                    ...item,
                    isSubtext: true,
                });
            }
            hasOnlyDescriptionAndValue(item) && renderItems.push(item);
        };
        generateFactItem(_renderItem);
        return renderItems && renderItems.map((data, index) => {
            if (data?.isSubtitle && data?.description) {
                return (React.createElement(View, { style: {
                        paddingTop: 8,
                        paddingBottom: 8,
                    } },
                    React.createElement(Typography, { label: `${data?.description}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '700', color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_500, lineHeight: 20 })));
            }
            else if (data?.isSubtext && data?.subText) {
                return (React.createElement(View, { style: {
                        paddingTop: 8,
                        paddingBottom: 8,
                    } },
                    React.createElement(Typography, { label: `${data?.subText}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_500, lineHeight: 20 })));
            }
            return (data?.description || data?.value) && (React.createElement(React.Fragment, null,
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: 8,
                        paddingBottom: 8,
                    } },
                    React.createElement(Typography, { label: `${data?.description}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_500, lineHeight: 20 }),
                    React.createElement(Typography, { label: `${data?.value && data?.value !== '' ? data?.value : 'N/A'}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_500 }))));
        });
    };
    const kfsDetailCard = (React.createElement(View, { style: {
            width: '100%',
            backgroundColor: isDarkMode ? '#1C1E24' : '#FFF',
            paddingHorizontal: 16,
            paddingTop: 16,
        } },
        React.createElement(Typography, { label: `List of parameters`, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_500, lineHeight: 24 }),
        React.createElement(Accordion, null,
            kfsData &&
                Object.keys(kfsData).map((key, index) => {
                    const { description, ...rest } = kfsData[key];
                    return (React.createElement(AccordionItem, { isDarkMode: isDarkMode, id: `acd_setCreditLimit_${(index + 1)}`, title: `${kfsData[key]?.description}`, showDivider: true }, key !== 'OTHER_DISCLOSURE_DETAILS'
                        ? (React.createElement(React.Fragment, null,
                            React.createElement(View, { style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    paddingTop: 8
                                } }, renderFactItem({ ...rest }))))
                        : React.createElement(React.Fragment, null)));
                }),
            React.createElement(AccordionItem, { isDarkMode: isDarkMode, id: `acd_setCreditLimit_detailRepaymentScheduleCard`, title: 'Detailed repayment schedule', showDivider: false }, detailRepaymentScheduleCard))));
    const _bodyChild = () => {
        return (React.createElement(ScrollView, { style: {
                height: '100%',
                flex: 1,
                paddingBottom: 160
            }, nestedScrollEnabled: true, showsVerticalScrollIndicator: false },
            React.createElement(View, { style: {
                    width: '100%',
                    paddingVertical: 12,
                    paddingHorizontal: 16,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                } },
                React.createElement(Typography, { label: `LENDING PARTNER`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS, fontWeight: '400', lineHeight: 16, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal }),
                React.createElement(View, null,
                    React.createElement(Icon, { name: getLenderIcon(_lenderData?.lenderAccountId) }))),
            overViewDetailCard,
            React.createElement(View, { style: { height: 14 } }),
            kfsDetailCard));
    };
    return Platform.OS === 'web' ? (React.createElement(View, { style: [
            styles.container,
            { height: height }
        ] },
        React.createElement(ScrollView, { style: [styles.body, { height: height - 57, backgroundColor: colorMapping[ColorTokens.Primary_05] }], nestedScrollEnabled: true, scrollEnabled: true, showsVerticalScrollIndicator: false }, _bodyChild()))) : (React.createElement(View, { style: [
            styles.container,
            { height: height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: styles.header }, _headerChild),
            React.createElement(ScrollView, { style: [styles.body, { height: height - 57, backgroundColor: colorMapping[ColorTokens.Primary_05] }], nestedScrollEnabled: true, scrollEnabled: true }, _bodyChild()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        marginLeft: -16,
        marginRight: -16
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 50
    },
    body: {
        paddingBottom: 16,
        paddingHorizontal: 16
    },
    footer: {
        position: 'absolute',
        bottom: '0',
        zIndex: 99,
        width: '100%',
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        shadowColor: '#D0D5DD',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.25,
        shadowRadius: 6,
        elevation: 2,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionLeftCardContainer: {
        flex: 3,
        display: 'flex',
        flexDirection: 'row',
    },
    transactionRightCardContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    tableContainer: {
        paddingTop: 30,
        backgroundColor: "#fff"
    },
    tableHead: {
        height: 40,
        backgroundColor: "#F9FAFB",
    },
    tableText: {
        textAlign: "left",
        fontWeight: '400',
        fontSize: 12,
        lineHeight: 18,
        paddingVertical: 12,
        paddingHorizontal: 12,
        color: '#667085'
    },
    tableHeadText: {
        textAlign: "left",
        fontWeight: '400',
        fontSize: 12,
        lineHeight: 18,
        color: '#667085',
        padding: 12
    },
    tableDataWrapper: { marginTop: -1 },
    tableRow: {},
});
export default (KFSPage);
